import User from '@/app/_components/ui/icons/User.svg';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';
import Login from '@/app/_components/ui/icons/Login.svg';
import { signOut, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';

export default function UserMenu() {
  const { data: session } = useSession();
  const isUser = !!session?.user;
  const [openMenu, setOpenMenu] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const menu = useRef(null);
  const closeOpenMenus = (e) => {
    if (menu.current && openMenu && !menu.current.contains(e.target)) {
      setOpenMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeOpenMenus);
    return () => {
      document.addEventListener('mousedown', closeOpenMenus);
    };
  });
  return (
    <div className="head-account px-3 border-l-2 border-light-gray-200 relative">
      {/* check state */}
      {isUser ? (
        <>
          <div
            className="flex justify-center items-center gap-2  rounded-md cursor-pointer transition-all duration-200"
            onClick={() => setOpenMenu((current) => !current)}
          >
            <span className="">
              <User />
            </span>
            <span>
              <SmallArrowDown fill="#2A75BB" />
            </span>
          </div>
          <div
            className={`userMenu absolute shadow-md bg-white p-4 w-48 -right-12 top-10 z-10 rounded-md ${
              openMenu ? 'block' : 'hidden'
            }`}
            ref={menu}
          >
            <ul className="flex flex-col leading-10 text-sm font-bold">
              <li>
                <Link href="/profile">حساب کاربری</Link>
              </li>
              <li>
                <Link href="/profile/lists">لیست ها</Link>
              </li>
              <li>
                <Link href="/profile/orders">سفارشات</Link>
              </li>
              <li>
                <Link href="/profile/comments">دیدگاه ها</Link>
              </li>
              <li>
                <div
                  className="cursor-pointer"
                  onClick={() =>
                    signOut({
                      callbackUrl: pathname || '/',
                      redirect: true,
                    })
                  }
                >
                  خروج از حساب کاربری
                </div>
              </li>
            </ul>
          </div>
        </>
      ) : (
        <button
          className="flex justify-center items-center gap-1 text-sm  font-medium text-color-primary"
          onClick={() => {
            router.push(
              `/users/login?callbackUrl=${encodeURIComponent(pathname)}`
            );
          }}
        >
          <Login />
          <span>ورود | ثبت نام</span>
        </button>
      )}
    </div>
  );
}
